import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import LandlordDetailedReport from './LandlordDetailedReport';

export const FinanceModule: React.FC = () => (
  <>
    <Route exact path={APP_ROUTES.FINANCE_MODULE.FULL_PATH}>
      <Redirect
        to={(APP_ROUTES.FINANCE_MODULE.CHILDREN as RouteConfig).LANDLORD_DETAILED_REPORT.FULL_PATH}
      />
    </Route>
    <Route
      exact
      path={(APP_ROUTES.FINANCE_MODULE.CHILDREN as RouteConfig).LANDLORD_DETAILED_REPORT.FULL_PATH}
      component={LandlordDetailedReport}
    />
  </>
);
